import React, {useState,useEffect} from 'react';
import ReactDOM from 'react-dom'
import axios from 'axios'
import ReactModal from 'react-modal';
import Loader from '../../shared/loader'

ReactModal.setAppElement('body');

const ModalStyles = {
  overlay: {
	  backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content : {
	padding: '1rem',
	width: 'auto',
	maxWidth: '800px',
	height: 'auto',
	top: '50%',
	left: '50%',
	right: 'auto',
	bottom: 'auto',
	marginRight: '-50%',
	paddingTop: '2.5rem',
	transform: 'translate(-50%, -50%)'
  }
};

const Terms = ({ banner }) => {

	const [ terms, showTerms ] = useState( false )
	const [ loading, setLoading ] = useState( false )
	const [ document, setDocument ] = useState( false )

	useEffect(() => {
		if( terms ) {
			setLoading( true );
			const url = '/suppliers/' + banner.id + '/terms';
			axios.get( url ).then(response => {
				setDocument( response.data )
				setLoading( false );
			}).catch(err => {
				setTerms(false)
				setLoading( false );
			});
		} else {
			setDocument( false )
		}
	}, [terms]);
	
	const renderBanner = ( type ) => {
		switch( type ) {
		case 'product':
			return <Product config={banner.config} showTerms={showTerms} />
		case 'supplier':
			return <Supplier config={banner.config} showTerms={showTerms} />
		default:
			return <User config={banner.config} showTerms={showTerms} />
		}
	}
	
	return ( 
		<>
		{renderBanner( banner.type )}
		<ReactModal
			isOpen={terms}
			contentLabel="Terms & Conditions"
			style={ModalStyles}
		>
			<button onClick={() => showTerms(false)} className="close-button clearfix" aria-label="Close modal"><span aria-hidden="true">×</span></button>
			{loading? <Loader /> : null }
			{document ? (
					<div dangerouslySetInnerHTML={{__html: document}} style={{height: '400px', overflow: 'scroll'}}></div>
			) : null}
		</ReactModal>
		</>
	)
}

const Product = ({ config, showTerms }) => {
	
	const deposit_tag = !config.deposit.refundable ? 'Non-Refundable ' : null
	const pp_tag = config.deposit.perPerson ? ' Per Person' : null
	
	return (
		<div className="cancellation">
			<h2>Cancellations</h2>
			<div className="wrapper">
				<div className="cancel-left">
					<svg className="secure-icon" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24">
						<path id="Path_4734" d="M21.768,6.74v-.018c-.01-.221-.017-.455-.021-.715-.024-1.274-1.025-2.315-2.297-2.388-2.413-.05-4.715-1.02-6.436-2.713l-.015-.013c-.564-.521-1.434-.521-1.997,0l-.015.014c-1.722,1.693-4.025,2.664-6.439,2.713-1.271.074-2.271,1.115-2.295,2.388-.004.258-.011.492-.021.714v.041c-.052,2.696-.115,6.05,1.008,9.097.59,1.632,1.538,3.111,2.777,4.328,1.555,1.458,3.411,2.555,5.437,3.216.073.025.148.046.224.06.214.043.433.043.647,0,.076-.015.151-.036.224-.061,2.025-.662,3.88-1.76,5.433-3.217,1.239-1.217,2.188-2.696,2.778-4.329,1.123-3.054,1.059-6.416,1.008-9.117ZM19.491,15.392c-1.184,3.21-3.601,5.414-7.389,6.739-.014.005-.028.009-.043.012-.039.008-.08.008-.119,0-.014-.003-.029-.007-.043-.011-3.792-1.323-6.21-3.526-7.393-6.736-1.035-2.807-.976-5.888-.924-8.605v-.015c.011-.234.017-.478.021-.747.011-.566.456-1.028,1.021-1.06,1.381-.057,2.741-.355,4.019-.882,1.221-.52,2.332-1.267,3.275-2.2.048-.044.121-.044.168,0,.943.933,2.053,1.68,3.273,2.2,1.278.527,2.638.826,4.018.884.565.032,1.01.494,1.021,1.06.004.27.011.515.022.747.05,2.718.109,5.801-.928,8.614Z"/>
						<path id="Path_4735" d="M11.999,6.269c-3.165,0-5.731,2.566-5.731,5.731s2.566,5.731,5.731,5.731,5.731-2.566,5.731-5.731h0c-.003-3.164-2.567-5.728-5.731-5.731ZM11.999,16.382c-2.42,0-4.381-1.962-4.381-4.381s1.962-4.381,4.381-4.381,4.381,1.962,4.381,4.381c-.003,2.419-1.963,4.379-4.381,4.381Z"/>
						<path id="Path_4736" d="M13.647,10.221l-2.662,2.662-.723-.723c-.263-.263-.689-.263-.952,0s-.263.689,0,.952l1.2,1.2c.262.263.688.264.951.002,0,0,.001-.001.002-.002l3.137-3.137c.263-.263.263-.689,0-.952s-.689-.263-.952,0h0v-.002Z"/>
					</svg>
				</div>
				<div className="cancel-right">
					
					{config.deposit ? (
						<p><span className="cancellation--severity">{config.deposit.amount}{pp_tag} {deposit_tag}Deposit</span> to secure your booking</p>
					) : null }
		
					{!config.deposit.refundable ? (
						<p>Final balance is due <span className="cancellation--severity">{config.cancellationDays}</span> days prior to the event date.<br /></p>
					) : (
						<>
							{!config.freeCancellation ? (
								<p>All monies paid are non-refundable<br /></p>
							) : (
								<p><span className="cancellation--severity">FREE</span> cancellation {config.cancellationDays} days prior to your activity taking place.</p>
							)}
						</>
					)}
		
					{config.preOrders > 0 ? (
						<p><span className="cancellation--severity">Pre-Orders</span> Required {config.preOrders} days prior to the event date</p>
					) : null}
					
					<p><a onClick={() => showTerms(true)}>View terms and conditions</a></p>
				</div>
			</div>
		</div>
	)
	
}


const User = ({ config, showTerms }) => {
	
	const icon = config.inCancellation || config.nonRefundable || config.nonRefundableDeposit ? 'icon icon-secure red' : 'icon icon-secure';
	
	const refundType = config.paidByDeposit && config.nonRefundableDeposit ? 'partial' : 'full'
	const finalBalance = config.paidByDeposit && !config.fullyPaid ? <><br />Final balance {config.depositDatePassed ? 'was' : 'is'} due on <span className="cancellation--severity">{config.balanceDate}</span></> : null
	const renderMessage = () => {
		
		if( config.nonRefundable ) {
			//not refundable
			return( <>All monies paid are non-refundable.</> )
		} else {
	
			if( config.booking ) {
				//booking
				if( config.inCancellation ) {
					return( 
						<>
							The cancellation date has now passed, you can still cancel but you will not receive a refund.{finalBalance}
						</> 
					)
				} else {
					return (
						<>Your have up until <b>{config.cancelDate}</b> at <b>{config.cancelTime}</b> to cancel and receive a {refundType} refund.{finalBalance}</>
					)
				}
			} else {
				//enquiry
				if( config.inCancellation ) {
					return( <>The cancellation date has now passed</> )
				} else {
					if( config.nonRefundableDeposit ) {
						return( <>Cancel up to {config.cancelDate} at {config.cancelTime} to receive a partial refund.</> )
					} else {
						return( <><span className="cancellation--severity">FREE</span> cancellation up to {config.cancelDate} at {config.cancelTime}.</> )
					}
				}
			}
		}
	}
	
	const hasPreOrder = () => {
		if( config.preOrders > 0 ) {
			return (
				<p><span className="cancellation--severity">Pre-Orders</span> Required {config.preOrders} days prior to the event date</p>
			)
		} else {
			return null;
		}
	}
	
	return (
		<div className="content-box border cancellation-small">
			<h2>Cancellations</h2>
			<div className="clearfix">
				<div className="cancel-left">
					<span className={icon}></span>
				</div>
				<div className="cancel-right">
					<p>	
						{renderMessage()}
						<br />
						<a onClick={() => showTerms(true)}>View terms and conditions</a>
					</p>
					{hasPreOrder()}
					
				</div>
			</div>
		</div>
	)
	
}

const Supplier = ({ config, showTerms }) => {
	
	
	const renderBookingMessage = () => {
		
		const refundType = config.nonRefundableDeposit ? 'partial' : 'full'
		
		if( config.nonRefundable ) {
			return ( <>All monies paid are non-refundable</> )
		} else {
			return (
				<>
					<>This booking was made on a cancellation basis of <b>{config.cancellationDays}</b> days.</>
					{config.inCancellation ? (
						<>The cancellation date has now passed, the customer can still cancel but they will not receive a refund.</>
					) : (
						<>The customer has up until <b>{config.cancelDate}</b> at <b>{config.cancelTime}</b> to cancel and receive a {refundType} refund.</>
					)}
				</>
			)
		}
	}
	
	return (
		<div className="content-box border cancellation">
			<h2>Cancellations</h2>
			<div className="clearfix">
				<div className="cancel-left"><span className="icon icon-secure"></span></div>
				<div className="cancel-right">
					<>
					{config.booking ? (
						<>{renderBookingMessage()}</>
					) : (
						<>This activity has cancellation policy of <b>{config.cancellationDays}</b> days.</>
					)}
					</>
				</div>
			</div>
		</div>
	)
	
}

document.addEventListener('DOMContentLoaded', () => {

	var terms_list = document.querySelectorAll('.cpt-terms');
	var termsList = [...terms_list];

	termsList.forEach(terms => {

		const banner = JSON.parse(terms.getAttribute('banner'));

		ReactDOM.render(
			<Terms
				banner={banner}
			/>,
			terms,
		)
		});
})
